import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import JokoakNavbar from '../aurrera-jokoak/JokoakNavbar';
import NagusiBackNav from '../common/NagusiBackNav';
import LogInModal from 'flarum/forum/components/LogInModal';
export default class GorbeaVotePage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "seasonParam", '');
    _defineProperty(this, "seasonId", 0);
    _defineProperty(this, "fechaCierre", null);
    _defineProperty(this, "isClosed", false);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "saving", false);
    _defineProperty(this, "rivals", []);
    _defineProperty(this, "players", []);
    _defineProperty(this, "voteExists", false);
    _defineProperty(this, "voteId", 0);
    // Form State
    _defineProperty(this, "classification", []);
    // Ordered array of rival IDs (strings)
    _defineProperty(this, "maxGoleadorLiga", '');
    _defineProperty(this, "maxGoleadorTotal", '');
    _defineProperty(this, "maxAsistenteLiga", '');
    _defineProperty(this, "maxAsistenteTotal", '');
    _defineProperty(this, "resultadoCopa", '');
    _defineProperty(this, "porteriasCero", 0);
    _defineProperty(this, "goleadasFavor", 0);
    _defineProperty(this, "goleadasContra", 0);
    // Drag and drop state
    _defineProperty(this, "draggedIndex", null);
    _defineProperty(this, "copaOptions", ['Primera ronda', 'Segunda ronda', 'Dieciseisavos de final', 'Octavos de final', 'Cuartos de final', 'Semifinales (ida y vuelta)', 'Final', 'Campeón']);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.seasonParam = m.route.param('season') || '2025-2026';
    this.loadData();
  }
  loadData() {
    this.loading = true;

    // 1. Fetch seasons to find active one and its deadline
    const pSeasons = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/seasons'
    });
    const pRivals = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/rivals?season=".concat(this.seasonParam)
    });

    // 3. Fetch players
    const pPlayers = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/players'
    });
    Promise.all([pSeasons, pRivals, pPlayers]).then(_ref => {
      let _ref2 = _slicedToArray(_ref, 3),
        seasonsResp = _ref2[0],
        rivalsResp = _ref2[1],
        playersResp = _ref2[2];
      const seasons = app.store.pushPayload(seasonsResp);
      const seasonName = this.seasonParam.replace('-', '/');
      const season = seasons.find(s => s.name() === seasonName || s.name() === this.seasonParam);
      if (!season) {
        this.loading = false;
        m.redraw();
        return;
      }
      this.seasonId = season.id();
      const dateStr = season.attribute('fechaCierreVotacionesPastorGorbea');
      this.fechaCierre = dateStr ? new Date(dateStr) : null;
      this.isClosed = this.fechaCierre ? new Date() > this.fechaCierre : false;
      this.players = app.store.pushPayload(playersResp) || [];
      const primaryTeamId = app.forum.attribute('nagusiMatchRatingsPrimaryTeamId') || '531';
      this.players = this.players.filter(p => p.isActive() && p.attribute('entityType') === 'player' && (p.teams() || []).some(t => String(t.id()) === String(primaryTeamId)));
      // Sort players alphabetically
      this.players.sort((a, b) => a.name().localeCompare(b.name()));
      const allRivals = app.store.pushPayload(rivalsResp) || [];
      // Filter rivals to Primera Division (1ª) only
      this.rivals = allRivals.filter(r => r.attribute('division') === '1ª');
      if (!app.session.user) {
        this.classification = this.rivals.map(r => String(r.id()));
        this.loading = false;
        m.redraw();
        return;
      }

      // 4. Fetch user's current vote if it exists
      return app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/gorbea-vote',
        params: {
          season_id: this.seasonId
        }
      }).then(voteResp => {
        if (voteResp && voteResp.data) {
          const vote = voteResp.data.attributes;
          this.voteExists = true;
          this.voteId = parseInt(voteResp.data.id);
          this.classification = vote.classification || [];
          this.maxGoleadorLiga = vote.maxGoleadorLiga ? String(vote.maxGoleadorLiga) : '';
          this.maxGoleadorTotal = vote.maxGoleadorTotal ? String(vote.maxGoleadorTotal) : '';
          this.maxAsistenteLiga = vote.maxAsistenteLiga ? String(vote.maxAsistenteLiga) : '';
          this.maxAsistenteTotal = vote.maxAsistenteTotal ? String(vote.maxAsistenteTotal) : '';
          this.resultadoCopa = vote.resultadoCopa || '';
          this.porteriasCero = vote.porteriasCero || 0;
          this.goleadasFavor = vote.goleadasFavor || 0;
          this.goleadasContra = vote.goleadasContra || 0;
        }

        // If no vote exists, initialize classification with the default rivals order
        if (this.classification.length === 0) {
          this.classification = this.rivals.map(r => String(r.id()));
        } else {
          // Ensure all rivals of Primera Division are in the classification array
          const currentIds = this.rivals.map(r => String(r.id()));
          // Filter out any IDs that are no longer in Primera Division
          this.classification = this.classification.filter(id => currentIds.includes(String(id)));
          // Add any new Primera Division teams that were not in the array
          currentIds.forEach(id => {
            if (!this.classification.includes(String(id))) {
              this.classification.push(String(id));
            }
          });
        }
        this.loading = false;
        m.redraw();
      });
    }).catch(err => {
      this.loading = false;
      m.redraw();
    });
  }
  saveVote() {
    if (this.isClosed || !app.session.user) return;
    this.saving = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/gorbea-vote',
      body: {
        data: {
          attributes: {
            seasonId: this.seasonId,
            classification: this.classification,
            maxGoleadorLiga: this.maxGoleadorLiga,
            maxGoleadorTotal: this.maxGoleadorTotal,
            maxAsistenteLiga: this.maxAsistenteLiga,
            maxAsistenteTotal: this.maxAsistenteTotal,
            resultadoCopa: this.resultadoCopa,
            porteriasCero: this.porteriasCero,
            goleadasFavor: this.goleadasFavor,
            goleadasContra: this.goleadasContra
          }
        }
      }
    }).then(() => {
      this.saving = false;
      this.voteExists = true;
      const clubSlug = app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
      const gorbeaLabel = clubSlug === 'real-sociedad' ? 'Txindoki' : 'Gorbea';
      app.alerts.show({
        type: 'success'
      }, "Tu pron\xF3stico del Pastor del ".concat(gorbeaLabel, " ha sido guardado correctamente."));
      m.redraw();
    }).catch(() => {
      this.saving = false;
      m.redraw();
    });
  }

  // Drag & Drop helper handlers
  dragStart(e, index) {
    if (this.isClosed) return;
    this.draggedIndex = index;
    if (e.dataTransfer) {
      e.dataTransfer.effectAllowed = 'move';
    }
  }
  dragOver(e, index) {
    if (this.isClosed) return;
    e.preventDefault();
    if (this.draggedIndex === null || this.draggedIndex === index) return;
    const classification = [...this.classification];
    const draggedItem = classification[this.draggedIndex];
    classification.splice(this.draggedIndex, 1);
    classification.splice(index, 0, draggedItem);
    this.classification = classification;
    this.draggedIndex = index;
    m.redraw();
  }
  dragEnd() {
    this.draggedIndex = null;
  }

  // Button controls for accessibility and mobile
  moveUp(index) {
    if (this.isClosed || index === 0) return;
    const classification = [...this.classification];
    const temp = classification[index];
    classification[index] = classification[index - 1];
    classification[index - 1] = temp;
    this.classification = classification;
    m.redraw();
  }
  moveDown(index) {
    if (this.isClosed || index === this.classification.length - 1) return;
    const classification = [...this.classification];
    const temp = classification[index];
    classification[index] = classification[index + 1];
    classification[index + 1] = temp;
    this.classification = classification;
    m.redraw();
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "BolillaPage"
      }, m(LoadingIndicator, null));
    }
    const season = this.seasonParam || '2025-2026';
    const clubSlug = app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
    const isReal = clubSlug === 'real-sociedad';
    const gorbeaUrl = isReal ? 'pastor-del-txindoki' : 'pastor-del-gorbea';
    const gorbeaLabel = isReal ? 'Txindoki' : 'Gorbea';
    if (!this.fechaCierre) {
      return m("div", {
        className: "BolillaPage"
      }, m("div", {
        className: "container"
      }, m(NagusiBackNav, {
        parentUrl: "/aurrera-jokoak",
        parentLabel: "Aurrera Jokoak",
        title: "Pronosticar ".concat(gorbeaLabel)
      }), m("h2", {
        className: "BolillaPage-Title"
      }, "Trofeo Pastor del ", gorbeaLabel), m(JokoakNavbar, null), m("div", {
        className: "JokoakSubmenu"
      }, m(Link, {
        href: "/".concat(gorbeaUrl, "/").concat(season, "/clasificacion"),
        className: "JokoakSubmenu-link active"
      }, "\uD83C\uDFC6 Clasificaci\xF3n"), m(Link, {
        href: "/".concat(gorbeaUrl, "/").concat(season, "/pronosticos"),
        className: "JokoakSubmenu-link"
      }, "\uD83D\uDD2E Apuestas de foreros")), m("div", {
        className: "Alert Alert--warning",
        style: "margin-bottom: 30px; border-radius: 12px; padding: 15px 20px; display: flex; align-items: center; gap: 12px; justify-content: center;"
      }, m("i", {
        className: "fas fa-exclamation-triangle",
        style: "font-size: 1.2em;"
      }), m("span", null, m("strong", null, "Pron\xF3sticos no disponibles:"), " El periodo de pron\xF3sticos no ha sido configurado para esta temporada todav\xEDa."))));
    }
    const isReadOnly = this.isClosed || !app.session.user;

    // Map classified IDs to Rival objects
    const $rivalMap = {};
    this.rivals.forEach(r => {
      $rivalMap[String(r.id())] = r;
    });
    return m("div", {
      className: "BolillaPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      parentUrl: "/aurrera-jokoak",
      parentLabel: "Aurrera Jokoak",
      title: "Pronosticar ".concat(gorbeaLabel)
    }), m("h2", {
      className: "BolillaPage-Title"
    }, "Trofeo Pastor del ", gorbeaLabel), m(JokoakNavbar, null), m("div", {
      className: "JokoakSubmenu"
    }, m(Link, {
      href: "/".concat(gorbeaUrl, "/").concat(season, "/clasificacion"),
      className: "JokoakSubmenu-link"
    }, "\uD83C\uDFC6 Clasificaci\xF3n"), m(Link, {
      href: "/".concat(gorbeaUrl, "/").concat(season, "/pronosticar"),
      className: "JokoakSubmenu-link active"
    }, "\u26F0\uFE0F Pronosticar"), m(Link, {
      href: "/".concat(gorbeaUrl, "/").concat(season, "/pronosticos"),
      className: "JokoakSubmenu-link"
    }, "\uD83D\uDD2E Apuestas de foreros")), !app.session.user ? m("div", {
      className: "BolillaWidget-GuestMessageWrapper BolillaNoActiveGame",
      style: "margin-bottom: 40px;"
    }, m("p", {
      className: "BolillaWidget-GuestMessage",
      style: "margin-bottom: 15px; font-weight: 500;"
    }, "Inicia sesi\xF3n para participar en el Trofeo Pastor del ", gorbeaLabel, "."), m(Button, {
      className: "Button Button--primary",
      onclick: () => app.modal.show(LogInModal)
    }, m("i", {
      className: "fas fa-sign-in-alt",
      style: "margin-right: 6px;"
    }), "Acceder al foro")) : this.isClosed ? m("div", {
      className: "Alert Alert--warning",
      style: "margin-bottom: 30px; border-radius: 12px; padding: 15px 20px; display: flex; align-items: center; gap: 12px;"
    }, m("i", {
      className: "fas fa-lock",
      style: "font-size: 1.2em;"
    }), m("span", null, m("strong", null, "Pron\xF3sticos Cerrados:"), " El periodo de pron\xF3sticos ha finalizado el ", this.fechaCierre ? this.fechaCierre.toLocaleString() : 'la fecha límite', ". Solo puedes ver tu pron\xF3stico guardado.")) : this.fechaCierre && m("div", {
      className: "Alert Alert--info",
      style: "margin-bottom: 30px; border-radius: 12px; padding: 15px 20px; display: flex; align-items: center; gap: 12px;"
    }, m("i", {
      className: "far fa-clock",
      style: "font-size: 1.2em;"
    }), m("span", null, "Puedes enviar y cambiar tu pron\xF3stico hasta el ", m("strong", null, this.fechaCierre.toLocaleString()), ".")), m("div", {
      className: "Gorbea-Form"
    }, m("div", {
      className: "Gorbea-Section"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0 0 15px 0; border-bottom: 2px solid rgba(128,128,128,0.2); padding-bottom: 10px;"
    }, "\uD83D\uDEE1\uFE0F Ordenar Clasificaci\xF3n Primera Divisi\xF3n"), m("p", {
      style: "font-size: 12px; margin-bottom: 20px; opacity: 0.8;"
    }, isReadOnly ? 'Esta es tu ordenación enviada.' : 'Arrastra los equipos para ordenarlos del 1º al 20º en tu pronóstico de final de liga.'), m("div", {
      className: "Gorbea-RivalsList",
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, this.classification.map((rivalId, index) => {
      const rival = $rivalMap[String(rivalId)];
      if (!rival) return null;
      const localTeamName = app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Athletic Club';
      const isAthletic = rival.name() === localTeamName;
      return m("div", {
        key: rival.id(),
        draggable: !isReadOnly,
        ondragstart: e => this.dragStart(e, index),
        ondragover: e => this.dragOver(e, index),
        ondragend: () => this.dragEnd(),
        style: "display: flex; align-items: center; justify-content: space-between; padding: 8px 12px; border-radius: 8px; border: 1px solid ".concat(isAthletic ? 'var(--primary-color)' : 'rgba(128,128,128,0.2)', "; background: ").concat(isAthletic ? 'rgba(238, 37, 35, 0.12)' : 'var(--control-bg, rgba(255, 255, 255, 0.03))', "; cursor: ").concat(isReadOnly ? 'default' : 'grab', "; transition: all 0.2s;")
      }, m("div", {
        style: "display: flex; align-items: center; gap: 10px;"
      }, m("span", {
        style: "font-weight: bold; opacity: 0.7; font-size: 14px; min-width: 20px;"
      }, index + 1), rival.attribute('escudo') ? m("img", {
        src: "/assets/extensions/nagusi-match-ratings/escudos/".concat(rival.attribute('escudo')),
        alt: "",
        style: "width: 24px; height: 24px; object-fit: contain;"
      }) : m("div", {
        style: "width: 24px; height: 24px; background: rgba(128,128,128,0.2); border-radius: 50%;"
      }), m("span", {
        style: "font-weight: ".concat(isAthletic ? 'bold' : 'normal', "; color: ").concat(isAthletic ? 'var(--primary-color)' : 'var(--heading-color)', ";")
      }, rival.name())), !isReadOnly && m("div", {
        style: "display: flex; gap: 4px;"
      }, m("button", {
        className: "Button Button--icon Button--link",
        disabled: index === 0,
        onclick: () => this.moveUp(index),
        title: "Subir"
      }, m("i", {
        className: "fas fa-chevron-up",
        style: "font-size: 11px;"
      })), m("button", {
        className: "Button Button--icon Button--link",
        disabled: index === this.classification.length - 1,
        onclick: () => this.moveDown(index),
        title: "Bajar"
      }, m("i", {
        className: "fas fa-chevron-down",
        style: "font-size: 11px;"
      }))));
    }))), m("div", {
      style: "display: flex; flex-direction: column; gap: 30px;"
    }, m("div", {
      className: "Gorbea-Section"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0 0 20px 0; border-bottom: 2px solid rgba(128,128,128,0.2); padding-bottom: 10px;"
    }, "\uD83C\uDFC3\u200D\u2642\uFE0F Pron\xF3stico de Jugadores (Athletic Club)"), m("div", {
      className: "Form-group",
      style: "margin-bottom: 20px;"
    }, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 8px;"
    }, "M\xE1ximo Goleador en Liga"), m("select", {
      className: "FormControl",
      disabled: isReadOnly,
      value: this.maxGoleadorLiga,
      onchange: e => this.maxGoleadorLiga = e.target.value
    }, m("option", {
      value: ""
    }, "-- Elige un jugador --"), this.players.map(p => m("option", {
      value: p.id()
    }, p.name())))), m("div", {
      className: "Form-group",
      style: "margin-bottom: 20px;"
    }, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 8px;"
    }, "M\xE1ximo Goleador Total (Liga + Copa)"), m("select", {
      className: "FormControl",
      disabled: isReadOnly,
      value: this.maxGoleadorTotal,
      onchange: e => this.maxGoleadorTotal = e.target.value
    }, m("option", {
      value: ""
    }, "-- Elige un jugador --"), this.players.map(p => m("option", {
      value: p.id()
    }, p.name())))), m("div", {
      className: "Form-group",
      style: "margin-bottom: 20px;"
    }, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 8px;"
    }, "M\xE1ximo Asistente en Liga"), m("select", {
      className: "FormControl",
      disabled: isReadOnly,
      value: this.maxAsistenteLiga,
      onchange: e => this.maxAsistenteLiga = e.target.value
    }, m("option", {
      value: ""
    }, "-- Elige un jugador --"), this.players.map(p => m("option", {
      value: p.id()
    }, p.name())))), m("div", {
      className: "Form-group",
      style: "margin-bottom: 5px;"
    }, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 8px;"
    }, "M\xE1ximo Asistente Total (Liga + Copa)"), m("select", {
      className: "FormControl",
      disabled: isReadOnly,
      value: this.maxAsistenteTotal,
      onchange: e => this.maxAsistenteTotal = e.target.value
    }, m("option", {
      value: ""
    }, "-- Elige un jugador --"), this.players.map(p => m("option", {
      value: p.id()
    }, p.name()))))), m("div", {
      className: "Gorbea-Section"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0 0 20px 0; border-bottom: 2px solid rgba(128,128,128,0.2); padding-bottom: 10px;"
    }, "\uD83C\uDFC6 Copa del Rey"), m("div", {
      className: "Form-group",
      style: "margin: 0;"
    }, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 8px;"
    }, "\xBFHasta qu\xE9 ronda llegar\xE1 el Athletic Club?"), m("select", {
      className: "FormControl",
      disabled: isReadOnly,
      value: this.resultadoCopa,
      onchange: e => this.resultadoCopa = e.target.value
    }, m("option", {
      value: ""
    }, "-- Elige una ronda --"), this.copaOptions.map(opt => m("option", {
      value: opt
    }, opt))))), m("div", {
      className: "Gorbea-Section"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0 0 20px 0; border-bottom: 2px solid rgba(128,128,128,0.2); padding-bottom: 10px;"
    }, "\uD83D\uDCCA Estad\xEDsticas Especiales (Liga)"), m("div", {
      className: "Form-group",
      style: "margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center;"
    }, m("label", {
      style: "font-weight: bold; margin: 0;"
    }, "Porter\xEDas a cero del Athletic en Liga:"), m("input", {
      type: "number",
      className: "FormControl",
      disabled: isReadOnly,
      min: "0",
      max: "38",
      style: "width: 80px; text-align: center; border-radius: 8px;",
      value: this.porteriasCero,
      onchange: e => this.porteriasCero = parseInt(e.target.value) || 0
    })), m("div", {
      className: "Form-group",
      style: "margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center;"
    }, m("label", {
      style: "font-weight: bold; margin: 0;"
    }, "Goleadas a favor (3 goles de diferencia o m\xE1s):"), m("input", {
      type: "number",
      className: "FormControl",
      disabled: isReadOnly,
      min: "0",
      style: "width: 80px; text-align: center; border-radius: 8px;",
      value: this.goleadasFavor,
      onchange: e => this.goleadasFavor = parseInt(e.target.value) || 0
    })), m("div", {
      className: "Form-group",
      style: "margin: 0; display: flex; justify-content: space-between; align-items: center;"
    }, m("label", {
      style: "font-weight: bold; margin: 0;"
    }, "Goleadas en contra (3 goles de diferencia o m\xE1s):"), m("input", {
      type: "number",
      className: "FormControl",
      disabled: isReadOnly,
      min: "0",
      style: "width: 80px; text-align: center; border-radius: 8px;",
      value: this.goleadasContra,
      onchange: e => this.goleadasContra = parseInt(e.target.value) || 0
    }))), !isReadOnly && m(Button, {
      className: "Button Button--primary Button--block",
      style: "padding: 12px; border-radius: 12px; font-weight: bold; font-size: 1.1em; border: none; height: 48px;",
      onclick: () => this.saveVote(),
      loading: this.saving
    }, this.voteExists ? '🔄 Actualizar mi Pronóstico' : '💾 Guardar mi Pronóstico')))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/gorbea/GorbeaVotePage', GorbeaVotePage);